<template>
  <layout-basic>
    <div class="section">
      <b-loading :is-full-page="loader.isFullPage" :active.sync="loader.isLoading" :can-cancel="false"></b-loading>
      <div class="columns">
        <div class="column auto">
          <form
            id="app"
            action="#"
            novalidate
            enctype="multipart/form-data"
            method="post"
            v-on:submit="formSubmit"
          >
            <template>
              <br>
              <section>
                <b-field
                        label="Cloudprinter product category"
                        :type="{'is-danger': errors.has('product category')}"
                        :message="errors.first('product category')"
                >
                  <b-select
                      placeholder="Select the category"
                      expanded
                      v-model="productData.cp_product_category"
                      @input="onCategoryChange()"
                      v-validate="'required'"
                      name="product category"
                  >
                    <option v-for="(products, categoryName) in cpProductList"
                            :value="categoryName"
                            :key="categoryName">
                      {{ categoryName }}
                    </option>
                  </b-select>
                </b-field>
              </section>
            </template>

            <template v-if="productData.cp_product_category">
              <br>
              <section>
                <b-field label="Cloudprinter product"
                         :type="{'is-danger': errors.has('product')}"
                         :message="errors.first('product')">
                  <b-select
                          placeholder="Select the product"
                          expanded
                          v-model="productData.cp_product_reference"
                          @input="onProductSelect($event)"
                          v-validate="'required'"
                          name="product"
                  >
                    <option
                            v-for="product in cpProductList[productData.cp_product_category]"
                            :value="product.product_reference"
                            :key="product.product_reference">
                      {{ product.name }} ({{ product.availability }} available)
                    </option>
                  </b-select>
                </b-field>
              </section>
            </template>

            <div v-for="(option) in cpProductOptions" v-if="productData.cp_product_reference">
              <template>
                <br>
                <section>
                  <b-field
                          v-bind:label="option.option_name"
                          :type="{'is-danger': errors.has(option.option_name.toLowerCase())}"
                          :message="errors.first(option.option_name.toLowerCase())"
                  >
                    <b-select
                            placeholder="Select the option"
                            expanded
                            v-model="productData.cp_product_options[option.key]"
                            :name="option.option_name.toLowerCase()"
                            v-validate="'required'"
                    >
                      <option
                              v-for="option_value in option.option_values"
                              :value="option_value.key"
                              :key="option_value.key">
                        {{ option_value.value }}
                      </option>
                    </b-select>
                  </b-field>
                </section>
              </template>
            </div>

            <template v-if="isBookProductSelected()">
              <br>
              <section>
                <b-field
                        label="Page count"
                        :type="{'is-danger': errors.has('page count')}"
                        :message="errors.first('page count')"
                >
                  <b-input v-model="productData.cp_product_options['count_pages']" name="page count" v-validate="'required'"></b-input>
                </b-field>
              </section>
            </template>

            <template v-if="productData.cp_product_reference">
              <br>
              <section>
                <b-field label="Quantity"
                         :type="{'is-danger': errors.has('quantity')}"
                         :message="errors.first('quantity')">
                  <b-input
                          v-model="productData.quantity"
                          name="quantity"
                          type="number"
                          v-validate="{required: true, numeric: true, min_value: 1}"
                  ></b-input>
                </b-field>
              </section>
            </template>

            <template v-if="isBookProductSelected()">
              <br>
              <section>
                <b-field label="Cover PDF file url"
                         :type="{'is-danger': errors.has('cover PDF file url')}"
                         :message="errors.first('cover PDF file url')">
                  <b-input
                          v-model="productData.cp_file.cover_url"
                          name="cover PDF file url"
                          v-validate="{url: {require_protocol: true}, required:true}"
                  ></b-input>
                </b-field>
              </section>
            </template>

            <template v-if="isBookProductSelected()">
              <br>
              <section>
                <b-field label="Book PDF file url"
                         :type="{'is-danger': errors.has('book PDF file url')}"
                         :message="errors.first('book PDF file url')">
                  <b-input
                          v-model="productData.cp_file.book_url"
                          name="book PDF file url"
                          v-validate="{url: {require_protocol: true}, required:true}"
                  ></b-input>
                </b-field>
              </section>
            </template>

            <template v-if="!isBookProductSelected() && productData.cp_product_reference">
              <br>
              <section>
                <b-field label="Product PDF file url"
                         :type="{'is-danger': errors.has('product PDF file url')}"
                         :message="errors.first('product PDF file url')">
                  <b-input v-model="productData.cp_file.product_url"
                           name="product PDF file url"
                           v-validate="{url: {require_protocol: true}, required:true}"
                  ></b-input>
                </b-field>
              </section>
            </template>
            <br>
            <template>
              <section class="has-text-right">
                <input type="submit" name="submit" class="button is-info" value="Save">
              </section>
            </template>
          </form>
        </div>
      </div>
    </div>
  </layout-basic>
</template>

<script>

import LayoutBasic from '@/layouts/LayoutBasic'
import axios from 'axios'

export default {
  name: 'Products',
  components: {
    LayoutBasic
  },
  data () {
    return {
      loader: {
        isFullPage: true,
        isLoading: true,
      },
      productData: {
        zoho_product_id: null,
        cp_product_category: null,
        cp_product_reference: null,
        cp_product_options: {},
        cp_file: {
          product_url: null,
          cover_url:null,
          book_url:null
        },
        quantity: null
      },
      cpProductList: [],
      cpProductOptions: []
    }
  },

  created () {
    ZOHO.embeddedApp.on("PageLoad", (data) => {
        this.productData.zoho_product_id = data.EntityId[0];
        this.setFormData();
    });

    ZOHO.embeddedApp.init()
      .then(() => {
          this.loader.isLoading = true;
          ZOHO.CRM.CONNECTOR.invokeAPI("cloudprintercom.cloudprinter.productlist0", {})
            .then((data) => {
              const response = JSON.parse(data.response);
              let result = {};
              response.forEach((product) => {
                if (!result[product.category]) {
                    result[product.category] = [product];
                } else {
                    result[product.category].push(product);
                }
              });

              this.cpProductList = result;
          }).finally(() => {
            this.loader.isLoading = false;
          })
    });
  },

  methods: {
    onProductSelect: function () {
      this.productData.cp_product_options = {}
      this.setProductOptions()
    },

    onCategoryChange: function () {
      this.productData.cp_product_reference = null;
    },

    setProductOptions: function () {
      this.loader.isLoading = true
      this.cpProductOptions = []

      const requestData = {
        product_reference: this.productData.cp_product_reference
      }

      ZOHO.CRM.CONNECTOR.invokeAPI('cloudprintercom.cloudprinter.productinfo', requestData)
        .then((data) => {
          let productOptions = {}
          const productInfo = JSON.parse(data.response)

          productInfo.options.forEach(function (option) {
            if (!productOptions[option.type]) {
              productOptions[option.type] = {
                name: option.type_name,
                values: []
              }
            }

            let productOptionItem = {
              key: option.option_reference,
              value: option.note + ' (' + option.availability + ')' +  (option.default == 1 ? ' (Standart)' : '')
            }
            productOptions[option.type].values.push(productOptionItem)
          })

          for (var key in productOptions) {
            this.cpProductOptions.push({
              key: key,
              option_name: productOptions[key].name,
              option_values: productOptions[key].values
            })
          }

          this.loader.isLoading = false
        })
    },

    isBookProductSelected: function () {
      return ['Textbook BW', 'Textbook FC', 'Photobook', 'Brochure'].indexOf(this.productData.cp_product_category) !== -1
    },

    formSubmit: function (event) {
      event.preventDefault();

      this.$validator.validate().then((result) => {
        if (result) {
          this.beforeProductSave();
          axios.post('/product/save', this.productData)
            .then(() => {
              this.$toast.open({
                message: 'Successfully saved.',
                type: 'is-success'
              })
              ZOHO.CRM.UI.Popup.close()
            })
        }
      })
    },

    setFormData: function () {
      this.loader.isLoading = true
      const requestData = {
        zoho_product_id: this.productData.zoho_product_id
      }
      axios.post('/product/get', requestData)
        .then((response) => {
          const responseData = response.data
          this.productData.cp_product_category = responseData.cp_product_category
          this.productData.cp_product_reference = responseData.cp_product_reference
          this.productData.cp_product_options = responseData.cp_product_options

          if (!this.productData.cp_product_options) {
            this.productData.cp_product_options = {}
          }

          this.productData.quantity = responseData.quantity
          this.productData.cp_file = responseData.cp_file
          this.setProductOptions()
        })
        .finally(() => {
          this.loader.isLoading = false
        })
    },

    beforeProductSave() {
      //removing options that doesn`t belong to the product
      for (let optionType in this.productData.cp_product_options) {
        if (optionType == 'count_pages') {
          continue;
        }

        let correctOption = false;
        for (let cpProductOption of this.cpProductOptions) {
          if (cpProductOption.key === optionType) {
            correctOption = true;
            break;
          }
        }

        if (!correctOption) {
          delete this.productData.cp_product_options[optionType];
        }
      }
    }
  }
}
</script>
